module.exports = __webpack_public_path__ + "img/random_q_app.ca66be94.png";